export default __webpack_public_path__ + "static/media/golden-sholver-new.e2506a7d.png";